import {Directive, ElementRef, EventEmitter, HostListener, inject, Output} from "@angular/core";

@Directive({
  selector: '[accClickOutside]',
  standalone: true
})
export class AccClickOutsideDirective {

  @Output()
  accClickOutside: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  @HostListener('document:mousedown', ['$event'])
  onClick(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.accClickOutside.emit(event);
    }
  }

  private readonly elementRef: ElementRef = inject(ElementRef);
}
